// An agent's invitation belongs to the classic signup.
//
// The invitation page (ActorInvitation) sends the visitor on with
// ?ac=true&ag={agentId}&aPath={invitation}, and the classic wizard is what
// attaches the agent to the new account. The submission flow creates a
// self-represented account, so an invited visitor who lands here is sent back
// there (decided 2026-10-03). The invitation can be in the current URL or in
// the tracking cookie's stored query; `start` answers 409 agentInvitation as a
// backstop when the page misses it.

const CLASSIC_SIGNUP = "/actor/1";

// Where to send the visitor, or null when no query carries an invitation.
export const classicInvitationPath = (...queries: Array<string | null | undefined>): string | null => {
  for (const query of queries) {
    if (!query) continue;
    const params = new URLSearchParams(query.charAt(0) === "?" ? query : `?${query}`);
    let aPath = "";
    let agent = "";
    params.forEach((value, key) => {
      const name = key.toLowerCase();
      if (name === "apath" && value) aPath = value;
      if (name === "ag" && value) agent = value;
    });
    if (!aPath) continue;

    const out = new URLSearchParams();
    out.set("ac", "true");
    if (agent) out.set("ag", agent);
    out.set("aPath", aPath);
    return `${CLASSIC_SIGNUP}?${out.toString()}`;
  }
  return null;
};
